import React from 'react'
import { J2Validate } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Button, Card, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useRouting } from '../../hooks'
import useUserVehicles from '../../hooks/use-user-vehicles'

const useStyles = makeStyles()(theme => ({
  vehicleCardHeadline: {
    textAlign: 'center',
  },
  centeredIcon: {
    marginTop: theme.spacing(4),
    display: 'flex',
    height: '60px',
    width: '60px',
  },
  vehicleCardText: {
    textAlign: 'center',
  },
  vehicleCardButton: {},
}))

interface Props {
  installationId: string | undefined
}

/**
 * Represents the "connection successfull"-screen when your vehicle got successfully connected to your power station
 */
const ConnectionSuccessfull: React.FC<Props> = ({ installationId }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const { navigateToVehicleIntegrationMainPage } = useRouting()
  const { refetchVehicles } = useUserVehicles(Number(installationId))

  const navigateToVehicleList = (): void => {
    navigateToVehicleIntegrationMainPage()
    refetchVehicles()
  }

  return (
    <Card sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <J2Validate color="primary" className={classes.centeredIcon} />
      </Box>
      <Typography variant="h2" className={classes.vehicleCardHeadline}>
        {t('emobility.vehicle-integration.connection-successfull')}
      </Typography>
      <Typography variant="body2" className={classes.vehicleCardText}>
        {t('emobility.vehicle-integration.connecting-vehicle-discription')}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button variant="contained" className={classes.vehicleCardButton} onClick={navigateToVehicleList}>
          {t('emobility.vehicle-integration.vehicle-has-been-connected')}
        </Button>
      </Box>
    </Card>
  )
}

export default ConnectionSuccessfull
